import { ScriptDraft, ScriptRowErrors } from './types';

export const createEmptyRow = (): ScriptDraft => ({
  id: `row_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`,
  name: '',
  textContent: '',
  category: '',
});

export const isRowFilled = (row: ScriptDraft) =>
  Boolean(row.name.trim() || row.textContent.trim() || row.category.trim());

export const validateRows = (rows: ScriptDraft[]): Record<string, ScriptRowErrors> => {
  const errors: Record<string, ScriptRowErrors> = {};

  for (const row of rows) {
    if (!isRowFilled(row)) continue;

    const rowErrors: ScriptRowErrors = {};
    if (!row.name.trim()) {
      rowErrors.name = 'Обязательное поле';
    }
    if (!row.textContent.trim()) {
      rowErrors.textContent = 'Обязательное поле';
    }
    if (Object.keys(rowErrors).length > 0) {
      errors[row.id] = rowErrors;
    }
  }

  return errors;
};
